import { FC } from 'react';

import useIsMobile from '../../../../hooks/useIsMobile';
import { MARKET_CAP_RADAR_INTERNAL_SKELETON_ROWS } from '../../../MarketCapRadar.constants';
import { getMarketCapRowKey } from '../../../marketCapRadar.helpers';
import { MarketCapRadarInternalTabProps } from '../../MarketCapRadarInternal.types';
import MarketCapRadarInternalRow from '../MarketCapRadarInternalRow/MarketCapRadarInternalRow';
import MarketCapRadarInternalSkeletonRow from '../MarketCapRadarInternalSkeletonRow';

import styles from '../../MarketCapRadarInternal.module.scss';

const SKELETON_ROW_KEYS = Array.from(
  { length: MARKET_CAP_RADAR_INTERNAL_SKELETON_ROWS },
  (_, index) => `market-cap-skeleton-${index}`,
);

const MarketCapRadarInternalTab: FC<MarketCapRadarInternalTabProps> = ({
  rows,
  isLoading,
  renderHeaders,
  onSymbolClick,
}) => {
  const { isMobile } = useIsMobile();

  return (
    <div className={styles.tableContent}>
      {/* The designs only show the header row on the web table. */}
      {!isMobile && renderHeaders()}
      {isLoading
        ? SKELETON_ROW_KEYS.map(key => <MarketCapRadarInternalSkeletonRow key={key} />)
        : rows.map(row => (
          <MarketCapRadarInternalRow
            key={getMarketCapRowKey(row)}
            row={row}
            onSymbolClick={onSymbolClick}
          />
        ))}
    </div>
  );
};

export default MarketCapRadarInternalTab;
